<template>
  <div class="container page" style="background-color: #f4f4f4;">
    <van-nav-bar :title="$t('setting.login_pwd_tip')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#333" @click="back()" />
      </template>
      <!-- <template #right>
        <span class="nav-right" @click="save()" style="color: #f3c7a2;">{{$t("setting.save")}}</span>
      </template> -->
    </van-nav-bar>
    <div class="tab">
      <div class="tab-item" @click="changeType(1)" :class="{active:type==1}">{{ $t("setting.login_pwd_tip") }}</div>
      <div class="tab-item" @click="changeType(2)" :class="{active:type==2}">{{ $t("minex.change_pay_password") }}</div>
    </div>
    <van-cell-group>
      <div class="c_p_j" v-if="type==1||(type==2&&userInfo.paypassword)">
        {{ $t('setting.old_pwd') }}
        <div @click="show1=!show1">{{ show1 ? $t("minex.hide") : $t("minex.show") }}</div>
      </div>
      <van-field v-if="type==1||(type==2&&userInfo.paypassword)" v-model="old_password"  :placeholder="$t('setting.old_pwd_tip')" :type="show1?'text':'password'"/>
      <div class="c_p_j">
        {{ $t('setting.new_pwd') }}
        <div @click="show2=!show2">{{ show2 ? $t("minex.hide") : $t("minex.show") }}</div>
      </div>
      <van-field v-model="o_new_password" :placeholder="$t('setting.new_pwd_tip')" :type="show2?'text':'password'"/>
      <div class="c_p_j">
        {{ $t('setting.new_pwd') }}
        <div @click="show3=!show3">{{ show3 ? $t("minex.hide") : $t("minex.show") }}</div>
      </div>
      <van-field v-model="t_new_password" :placeholder="$t('setting.new_again_tip')" :type="show3?'text':'password'"/>
    </van-cell-group>
    <div class="sub-btn" @click="save()">
      {{ $t('q59') }}
    </div>
    <div class="sub-btn" style="margin-top: 0;" @click="reset()">
      {{ $t("minex.reset") }}
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      type:1,
      show1:false,
      show2:false,
      show3:false,
      o_new_password:"",
      t_new_password:"",
      old_password:"",
      userInfo:{}
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    changeType(type){
      this.type=type;
      this.reset()
    },
    reset(){
      this.o_new_password="";
      this.t_new_password="";
      this.old_password="";
    },
    save(){
      if(this.o_new_password === "" || this.o_new_password === null || this.o_new_password === undefined){
        this.$toast.fail(this.$t("setting.prefect"));
        return false;
      }
      if(this.t_new_password === "" || this.t_new_password === null || this.t_new_password === undefined){
        this.$toast.fail(this.$t("setting.prefect"));
        return false;
      }
      if(this.type==1||(this.type==2&&this.userInfo.paypassword)&&(this.old_password === "" || this.old_password === null || this.old_password === undefined)){
        this.$toast.fail(this.$t("setting.prefect"));
        return false;
      }
      if(this.o_new_password !== this.t_new_password){
        this.$toast(this.$t("setting.pwd_error"));
        return false;
      }
      if(this.o_new_password.length<6){
        this.$toast(this.$t("minex.pwd_min_six"));
        return false;
      }
      let data={}
      if(this.type==1){
        data={
          old_password:this.old_password,
          new_password:this.o_new_password,
        }
      }else{
        data={
          paypassword:this.old_password,
          paypassword2:this.o_new_password
        }
      }
      this.$http({
        method: 'get',
        data:data,
        url: this.type==1?'user_set_loginpw':'user_set_paypw'
      }).then(res=>{
        if(res.code === 200){
          this.$toast(res.msg);
          setTimeout(() => {
            localStorage.clear()
            this.$router.push("Login")
          }, 500);

        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    }
  },
  created() {
    this.type=this.$route.query.type
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserInfo();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.tab{
  background-color: #fff;
  height: 88px;
  display: flex;
  align-items: center;
  .tab-item{
    width: 50%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    color: #666;
    &.active{
      color: #f3c7a2;
      &::after{
        content: '';
        position: absolute;
        width: 100%;
        height: 4px;
        background-color: #f3c7a2;
        bottom: 0;
        left: 0;
      }
    }
  }
}
.sub-btn{
  background: rgb(151, 20, 151);
  display: inline-block;
  border: none;
  cursor: pointer;
  color: #fff;
  font-size: 32px;
  border-radius: 10px;
  margin: 60px 40px 30px 40px;
  font-weight: bold;
  text-align: center;
  padding: 20px 0;
}
.van-cell{
  background: #fff;
  margin: 0 30px;
  box-sizing: border-box;
  width: initial;
  border: 4px solid #cfc1c1;
  border-radius: 10px;
  font-size: 28px;
  padding: 20px 26px;
  /deep/ .van-field__control{
    color: #333;
  }
  &:after{
    display: none;
  }
}
.van-cell-group{
  background-color: transparent;
  &:after{
    display: none;
  }
}
.c_p_j{
  padding: 26px 30px;
  color: #000;
  font-size: 26px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  div{
    color: cornflowerblue;
  }
}
</style>
